export default "__VITE_ASSET__RqVK8VOK__"